import Slide from './Slide';
import { getElementIndex } from '../utils';
import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';
import throttle from 'lodash.throttle';
import Hammer from 'hammerjs';

export default class Story {
	constructor(el) {
		// DOM elements
		this.el = el;
		this.progressBar = el.querySelector('.c-progress-bar');
		this.progressBarIndicator = el.querySelector('.c-progress-bar__bar');
		this.nextButton = this.el.querySelector('.c-swiper__nav--next');
		this.prevButton = this.el.querySelector('.c-swiper__nav--prev');

		// Slides properties
		this.data = window.storyData;
		this.slides = this.data.map(data => new Slide(data));
		this.slides.forEach(slide => {
			slide.init(this.slides);
		});
		this.currentSlide = this.slides[0];
		this.active = false;
		this.controlsTimer = null;
	}

	init() {
		const swiperContainer = this.el.querySelector('.c-swiper .swiper-container');
		const cover = this.el.querySelector('.single-story-cover');
		const storyContent = this.el.querySelector('.single-story__content');
		const mc = new Hammer(storyContent);

		this.swiper = new Swiper(swiperContainer, {
			slidesPerView: 'auto',
			allowTouchMove: false,
			speed: 800,
			on: {
				init: this.setProgressBar.bind(this),
				slideChange: swiper => {
					this.setProgressBar(swiper);

					this.pauseVideos();

					if (this.currentSlide.type == '3-4' && this.currentSlide.subType == 'inc-text') {
						this.currentSlide.addIsActive();
					}

					// Eerste swiper slide
					// if (swiper.activeIndex == 0) {
					// 	if (this.currentSlide == this.slides[0]) {
					// 		this.prevButton.disabled = true;
					// 	} else {
					// 		this.prevButton.disabled = false;
					// 	}
					// } else {
					// 	this.prevButton.disabled = false;
					// }

					// Laatste swiper slide
					if (swiper.activeIndex >= swiper.slides.length - 1) {
						if (this.currentSlide == this.slides[this.slides.length - 1]) {
							this.nextButton.disabled = true;
						} else {
							this.nextButton.disabled = false;
						}
					} else {
						this.nextButton.disabled = false;
					}
				},
				slideNextTransitionStart(swiper) {},
				slideNextTransitionEnd(swiper) {},
				slidePrevTransitionStart(swiper) {},
				slidePrevTransitionEnd(swiper) {},
			},
		});

		mc.on('swipe', e => {
			if (!this.active) {
				this.activateSlider();
				return;
			}

			if (e.direction == 4) {
				this.prev();
			}

			if (e.direction == 2) {
				this.next();
			}
		});

		this.nextButton.addEventListener('click', e => {
			this.next();
		});

		this.prevButton.addEventListener('click', e => {
			this.prev();
		});

		document.addEventListener('keyup', e => {
			if (e.defaultPrevented) {
				return;
			}

			const key = e.key || e.keyCode;

			if (key === 'ArrowRight' || key === 39) {
				this.next();
			}

			if (key === 'ArrowLeft' || key === 37) {
				this.prev();
			}
		});

		// TODO: misschien nog toevoegen ivm Samsung? || navigator.userAgent.match(/Android/i)
		if (!window.matchMedia('(any-hover: none)').matches) {
			storyContent.addEventListener('mouseenter', this.toggleLights.bind(this));
			storyContent.addEventListener('mouseleave', this.toggleLights.bind(this));

			this.el.addEventListener(
				'mousemove',
				throttle(e => {
					window.clearTimeout(this.controlsTimer);

					this.el.classList.add('is-showing-controls');

					// Muis staat niet op een control element, zet een timeout om de controls te verbergen
					if (!(e.target && e.target.closest('.c-swiper-control'))) {
						this.controlsTimer = window.setTimeout(() => {
							this.el.classList.remove('is-showing-controls');
						}, 2000);
					}
				}, 100),
			);
		} else {
			// Op touch devices laat gelijk controls zien
			this.el.classList.add('is-showing-controls');

			document.addEventListener('menuopen', e => {
				this.turnLightsOn();
			});

			document.addEventListener('menuclosed', e => {
				this.dim();
			});
		}

		cover.addEventListener(
			'click',
			e => {
				this.activateSlider();
				e.preventDefault();
			},
			// {
			// 	once: true,
			// },
		);

		// Navigatie via de progressbar
		this.progressBar.addEventListener('click', e => {
			if (!e.target.closest('.c-progress-bar__button')) {
				return;
			}

			const index = getElementIndex(e.target);
			const swiperSlide = this.slides.find(slide => slide.slideId == index + 1); // Dit werkt omdat find het eerste item vind waarbij de conditie waar is. De eerste slide met een bepaald slideId is nooit een tekst

			if (this.currentSlide.slideId == swiperSlide.slideId) {
				return;
			}

			this.resetSlidesInSlide(); // Testkslides moeten gereset worden naar beginstatus
			this.closeLayers(); // Alle layers moeten gesloten worden
			this.currentSlide = swiperSlide;
			this.swiper.slideTo(index);

			e.preventDefault();
		});
	}

	activateSlider() {
		this.el.classList.add('has-active-slider');
		this.active = true;

		if (this.currentSlide.type == '3-4' && this.currentSlide.subType == 'inc-text') {
			this.currentSlide.addIsActive();
		}
	}

	deactivateSlider() {
		this.el.classList.remove('has-active-slider');
		this.active = false;
	}

	toggleLights() {
		if (!this.active) {
			return;
		}

		if (document.body.classList.contains('has-menu-open')) {
			this.turnLightsOn();
			return;
		}

		this.el.classList.contains('has-lights-on') ? this.dim() : this.turnLightsOn();
	}

	dim() {
		this.el.classList.remove('has-lights-on');
	}

	turnLightsOn() {
		this.el.classList.add('has-lights-on');
	}

	setProgressBar(swiper) {
		const index = swiper.activeIndex + 1;
		const total = swiper.slides.length;

		this.progressBarIndicator.style.width = `${(100 / total) * index}%`;
	}

	getNextSlide() {
		const index = this.slides.findIndex(slide => slide.id == this.currentSlide.id);

		if (index > this.slides.length) {
			return false;
		}

		return this.slides[index + 1];
	}

	getPrevSlide() {
		const index = this.slides.findIndex(slide => slide.id == this.currentSlide.id);

		if (index == 0) {
			return false;
		}

		return this.slides[index - 1];
	}

	next() {
		const nextSlide = this.getNextSlide();
		const method = this.swiper.slideNext.bind(this.swiper);

		this.goForwardOrBackward(nextSlide, method, 'next');
	}

	prev() {
		const prevSlide = this.getPrevSlide();
		const method = this.swiper.slidePrev.bind(this.swiper);

		this.goForwardOrBackward(prevSlide, method, 'prev');
	}

	goForwardOrBackward(slide, method, direction) {
		let changeSwiper = false;

		// Teruggaan naar een vorige slide die niet bestaat betekent dat de cover weer getoond moet worden
		if (!slide && direction == 'prev') {
			this.deactivateSlider();
			return;
		}

		if (!slide) {
			return;
		}

		if (slide.slideId !== this.currentSlide.slideId) {
			changeSwiper = true;
		}

		// Enter en leave methods alleen relevant bij forward/backward navigatie
		this.currentSlide.leave(direction).then(() => {
			slide.enter(direction);

			this.currentSlide = slide;

			if (changeSwiper) {
				// debugger;
				method();
			}

			if (direction == 'next') {
				// Eerste swiper slide
				// if (this.swiper.activeIndex == 0) {
				// 	this.prevButton.disabled = false;
				// }

				// Laatste swiper slide
				if (this.swiper.activeIndex >= this.swiper.slides.length - 1) {
					if (this.currentSlide == this.slides[this.slides.length - 1]) {
						this.nextButton.disabled = true;
					}
				}
			} else {
				// Eerste swiper slide
				// if (this.swiper.activeIndex == 0) {
				// 	if (this.currentSlide == this.slides[0]) {
				// 		this.prevButton.disabled = true;
				// 	} else {
				// 		this.prevButton.disabled = false;
				// 	}
				// }

				// Laatste swiper slide
				if (this.swiper.activeIndex >= this.swiper.slides.length - 1) {
					if (this.currentSlide == this.slides[this.slides.length - 1]) {
						this.nextButton.disabled = true;
					} else {
						this.nextButton.disabled = false;
					}
				}
			}
		});
	}

	resetSlidesInSlide() {
		// Reset alle slides waar mogelijk subslides in zitten
		this.slides
			.filter(slide => {
				return slide.type !== 'text';
			})
			.forEach(slide => {
				this.resetSlideInSlide(slide);
			});

		// Reset 3/4 slides met tekstblok
		this.slides
			.filter(slide => {
				return slide.type == '3-4' && slide.subType == 'inc-text';
			})
			.forEach(slide => slide.reset());
	}

	resetSlideInSlide(swiperSlide) {
		this.slides
			.filter(slide => {
				return slide.slideId == swiperSlide.slideId && slide.type == 'text';
			})
			.forEach(slide => slide.reset());
	}

	pauseVideos() {
		this.slides.forEach(slide => slide.pauseVideo());
	}

	closeLayers() {
		this.slides.forEach(slide => slide.closeLayer());
	}
}
